import { stateKey } from '../../../../app/state-key.js';
import { spotlightContentClick } from '../../../../features/commerce/spotlight-content/spotlight-content-actions.js';
import { buildInteractiveResultCore } from '../../../core/interactive-result/headless-core-interactive-result.js';
/**
 * Creates an `InteractiveSpotlightContent` sub-controller instance.
 *
 * @param engine - The headless commerce engine.
 * @param props - The configurable `InteractiveSpotlightContent` properties.
 * @returns An `InteractiveSpotlightContent` sub-controller instance.
 *
 * @group Buildable controllers
 * @category CoreInteractiveSpotlightContent
 */
export function buildCoreInteractiveSpotlightContent(engine, props) {
    let wasOpened = false;
    const getWarningMessage = () => {
        const { id, desktopImage } = props.options.spotlightContent;
        const warnings = [];
        if (!id) {
            warnings.push("- Could not retrieve 'id' property from spotlight content; this is required for analytics.");
        }
        if (!desktopImage) {
            warnings.push("- Could not retrieve 'desktopImage' property from spotlight content; this is required for analytics.");
        }
        if (warnings.length === 0) {
            return;
        }
        return `Some required analytics properties could not be retrieved from the spotlight content with \
id '${id}':\n\n${warnings.join('\n')}\n\nReview the configuration to ensure the spotlight content contains the correct metadata.`;
    };
    const logAnalyticsIfNeverOpened = () => {
        if (wasOpened) {
            return;
        }
        wasOpened = true;
        engine.dispatch(spotlightContentClick({
            id: props.options.spotlightContent.id,
            desktopImage: props.options.spotlightContent.desktopImage,
            position: props.options.spotlightContent.position,
            responseId: props.options.spotlightContent.responseId ??
                props.responseIdSelector(engine[stateKey]),
        }));
    };
    return {
        ...buildInteractiveResultCore(engine, props, logAnalyticsIfNeverOpened),
        warningMessage: getWarningMessage(),
    };
}
